import { useEffect, useState } from 'react'

import {
  getBidPriceWithLowestProbability,
  getClosestProbability,
  type BidProbability,
} from '../../domain/BidProbability'
import { getBidProbabilities } from '../../use-cases/bid/getBidProbabilities'

export function useBidProbability(
  bidOfferUUID: string,
  bidPrice: number,
  bidProbabilityEnabled: boolean = false
) {
  const [bidProbabilities, setBidProbabilities] = useState<BidProbability[]>()
  const [bidProbability, setBidProbability] = useState<number>()
  const [maxBidPrice, setMaxBidPrice] = useState<number>()

  useEffect(() => {
    if (!bidProbabilityEnabled) return

    async function fetchBidProbabilities() {
      const offerBidProbabilities = await getBidProbabilities(bidOfferUUID)
      setBidProbabilities(offerBidProbabilities)
    }

    setBidProbabilities([])
    fetchBidProbabilities()
  }, [bidOfferUUID, bidProbabilityEnabled])

  useEffect(() => {
    setBidProbability(getClosestProbability(bidPrice, bidProbabilities))
    const bidPriceWithLowestProbability = getBidPriceWithLowestProbability(bidProbabilities)
    setMaxBidPrice(bidPriceWithLowestProbability)
  }, [bidPrice, bidProbabilities])

  return { bidProbability, maxBidPrice }
}
